import { createContext, useContext } from "react";

export interface Navigation {
  path: string;
  navigate: (path: string, options?: { replace?: boolean }) => void;
}

export const NavigationContext = createContext<Navigation | null>(null);

export function useNavigation(): Navigation {
  const value = useContext(NavigationContext);
  if (!value) {
    throw new Error("useNavigation debe usarse dentro de RouterProvider.");
  }
  return value;
}
